import { Types as TYPES } from '../types';
import { Endpoints as ENDPOINTS } from '../endpoints';
import {
    decryptSingleTentData,
    decryptTentData,
} from '../../utils/crypt-module/decrypt';
import { useAuth as Auth_Util } from '../../custom-hooks/useAuth';
import Swal from 'sweetalert2';
const { getPrivateKey } = Auth_Util();

const actionType = TYPES.find((type) => type.actionName === 'tentAction');

const {
    ALL_TENT_FETCH_SUCCESS,
    ALL_TENT_FETCH_FAILED,
    ALL_TENT_FETCH_START,
    ALL_TENT_FETCH_STOP,

    SINGLE_TENT_FETCH_START,
    SINGLE_TENT_FETCH_STOP,
    SINGLE_TENT_FETCH_SUCCESS,
    SINGLE_TENT_FETCH_FAILED,

    TENT_CREATE_START,
    TENT_CREATE_SUCCESS,
    TENT_CREATE_FAILED,
    TENT_CREATE_STOP,

    TENT_UPDATE_START,
    TENT_UPDATE_SUCCESS,
    TENT_UPDATE_FAILED,
    TENT_UPDATE_STOP,

    TENT_DELETE_START,
    TENT_DELETE_SUCCESS,
    TENT_DELETE_FAILED,
    TENT_DELETE_STOP,
    RESET_TENT_STATUS,
    UPDATE_TENT_LOCALLY,

    PARTICIPANT_ASSIGNMENT_START,
    PARTICIPANT_ASSIGNMENT_SUCCESS,
    PARTICIPANT_ASSIGNMENT_FAILED,

    PARTICIPANT_DETACHMENT_START,
    PARTICIPANT_DETACHMENT_SUCCESS,
    PARTICIPANT_DETACHMENT_FAILED,
} = actionType.types;

const { baseUrl, routes } = ENDPOINTS;

export const tentActions = {
    allTentAction: (param) => (dispatch) => {
        dispatch({
            type: ALL_TENT_FETCH_START,
        });

        const { token } = param;

        const url = `${baseUrl}${routes.get.tent}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        })
            .then((resp) => resp.json())
            .then((res) => {
                if (res.success) {
                    const privateKey = getPrivateKey();

                    decryptTentData(res.data, privateKey).then(
                        (decryptedData) => {
                            if (
                                decryptedData &&
                                decryptedData.isDecrypted === undefined
                            ) {
                                dispatch({
                                    type: ALL_TENT_FETCH_SUCCESS,
                                    payload: decryptedData,
                                });
                            } else if (
                                decryptedData &&
                                decryptedData.isDecrypted !== undefined &&
                                !decryptedData.isDecrypted
                            ) {
                                Swal.fire({
                                    title: 'Decryption failed',
                                    text: 'Error decrypting  tent data',
                                    icon: 'error',
                                });
                            }
                        }
                    );
                } else {
                    dispatch({
                        type: ALL_TENT_FETCH_FAILED,
                    });
                }
            })
            .catch((e) => {
                dispatch({
                    type: ALL_TENT_FETCH_FAILED,
                });
            });
    },

    createTentAction: (params) => (dispatch) => {
        dispatch({
            type: TENT_CREATE_START,
        });

        const { tent, token } = params;
        const url = `${baseUrl}${routes.post.tent}`;

        fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify(tent),
            redirect: 'follow',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        })
            .then((resp) => resp.json())
            .then((res) => {
                if (!res.success) {
                    dispatch({
                        type: TENT_CREATE_FAILED,
                        payload: {
                            message: res.message || 'Tent creation failed',
                            errors: res.errors || {},
                        },
                    });
                } else {
                    const privateKey = getPrivateKey();

                    if (!privateKey) {
                        dispatch({
                            type: TENT_CREATE_FAILED,
                            payload: {
                                message: 'Private key not found',
                            },
                        });
                        return;
                    }

                    decryptSingleTentData(res.data, privateKey)
                        .then((decryptedData) => {
                            dispatch({
                                type: TENT_CREATE_SUCCESS,
                                payload: decryptedData,
                            });
                        })
                        .catch((error) => {
                            dispatch({
                                type: TENT_CREATE_FAILED,
                                payload: {
                                    message: 'Decryption failed',
                                    errors: error.message || {},
                                },
                            });
                        });
                }
            })
            .catch((e) => {
                console.error('Network or server error:', e);
                dispatch({
                    type: TENT_CREATE_FAILED,
                    payload: {
                        message: 'Network or server error',
                        errors: e.message || {},
                    },
                });
            });
    },

    resetTentAction: () => (dispatch) => {
        dispatch({
            type: RESET_TENT_STATUS,
        });
    },
    singleTentAction: (params) => (dispatch) => {
        dispatch({
            type: SINGLE_TENT_FETCH_START,
        });

        const { token, id } = params;
        const url = `${baseUrl}${routes.get.tent}/${id}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        })
            .then((resp) => resp.json())
            .then((res) => {
                if (res.success) {
                    const privateKey = getPrivateKey();

                    if (!privateKey) {
                        dispatch({
                            type: SINGLE_TENT_FETCH_FAILED,
                            payload: {
                                message: 'Private key not found',
                            },
                        });
                        return;
                    }

                    decryptSingleTentData(res.data, privateKey)
                        .then((decryptedData) => {
                            dispatch({
                                type: SINGLE_TENT_FETCH_SUCCESS,
                                payload: decryptedData,
                            });
                        })
                        .catch((error) => {
                            dispatch({
                                type: SINGLE_TENT_FETCH_FAILED,
                                payload: {
                                    message: 'Decryption failed',
                                    errors: error.message || {},
                                },
                            });
                        });
                } else {
                    dispatch({
                        type: SINGLE_TENT_FETCH_FAILED,
                    });
                }
            })
            .catch((e) => {
                dispatch({
                    type: SINGLE_TENT_FETCH_FAILED,
                });
            });
    },
    updateTentAction: (params) => (dispatch) => {
        if (!params || !params.id || !params.token) {
            dispatch({
                type: TENT_UPDATE_FAILED,
                error: 'Invalid parameters',
            });
            return;
        }

        dispatch({
            type: TENT_UPDATE_START,
        });

        const { token, id, encryptedFormData } = params;
        const url = `${baseUrl}${routes.update.tent}/${id}`;

        fetch(url, {
            method: 'PUT',
            body: JSON.stringify(encryptedFormData),
            redirect: 'follow',
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        })
            .then((resp) => resp.json())
            .then((res) => {
                if (res.success) {
                    const privateKey = getPrivateKey();

                    if (!privateKey) {
                        dispatch({
                            type: TENT_UPDATE_FAILED,
                            payload: {
                                message: 'Private key not found',
                            },
                        });
                        return;
                    }

                    decryptSingleTentData(res.data, privateKey)
                        .then((decryptedData) => {
                            dispatch({
                                type: TENT_UPDATE_SUCCESS,
                                payload: decryptedData,
                            });
                        })
                        .catch((error) => {
                            dispatch({
                                type: TENT_UPDATE_FAILED,
                                payload: {
                                    message: 'Decryption failed',
                                    errors: error.message || {},
                                },
                            });
                        });
                } else {
                    dispatch({
                        type: TENT_UPDATE_FAILED,
                        payload: {
                            message: res.message,
                            errors: res.errors,
                        },
                    });
                }
            })
            .catch((e) => {
                dispatch({
                    type: TENT_UPDATE_FAILED,
                    errors: e.message,
                });
            });
    },

    updateTentLocally: (updatedTent) => (dispatch) => {
        dispatch({
            type: UPDATE_TENT_LOCALLY,
            payload: updatedTent,
        });
    },

    tentDeleteAction: (params) => (dispatch) => {
        dispatch({ type: TENT_DELETE_START });

        const { id, token } = params;
        const url = `${baseUrl}${routes.delete.tent}/${id}`;

        fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        })
            .then((resp) => resp.json())
            .then((res) => {
                if (res.success) {
                    dispatch({
                        type: TENT_DELETE_SUCCESS,
                        payload: res.data,
                    });
                } else {
                    dispatch({
                        type: TENT_DELETE_FAILED,
                    });
                }
            })
            .catch((e) => {
                dispatch({
                    type: TENT_DELETE_FAILED,
                });
            });
    },

    assignParticipantAction: (params) => async (dispatch) => {
        dispatch({ type: PARTICIPANT_ASSIGNMENT_START });

        const { tent_id, participant_id, token } = params;
        const url = `${baseUrl}${routes.post.tents}/${tent_id}/participants/assign`;

        const data = { participant_id: [participant_id] };
        fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify(data),
            redirect: 'follow',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        })
            .then((resp) => resp.json())
            .then((res) => {
                if (!res.success) {
                    dispatch({
                        type: PARTICIPANT_ASSIGNMENT_FAILED,
                        payload: {
                            message: res.message,
                            errors: res.errors,
                        },
                    });
                } else {
                    dispatch({
                        type: PARTICIPANT_ASSIGNMENT_SUCCESS,
                        payload: res.data,
                    });

                    dispatch(
                        tentActions.singleTentAction({ token, id: tent_id })
                    );
                }
            })
            .catch((e) => {
                dispatch({
                    type: PARTICIPANT_ASSIGNMENT_FAILED,
                    payload: {
                        message: 'Something went wrong',
                        errors: e,
                    },
                });
            });
    },

    detachParticipantAction: (params) => async (dispatch) => {
        dispatch({ type: PARTICIPANT_DETACHMENT_START });

        const { tent_id, participant_id, token } = params;
        const url = `${baseUrl}${routes.post.tents}/${tent_id}/participants/remove`;

        const data = { participant_id: [participant_id] };
        fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify(data),
            redirect: 'follow',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        })
            .then((resp) => resp.json())
            .then((res) => {
                if (!res.success) {
                    dispatch({
                        type: PARTICIPANT_DETACHMENT_FAILED,
                        payload: {
                            message: res.message,
                            errors: res.errors,
                        },
                    });
                } else {
                    dispatch({
                        type: PARTICIPANT_DETACHMENT_SUCCESS,
                        payload: res.data,
                    });

                    dispatch(
                        tentActions.singleTentAction({ token, id: tent_id })
                    );
                }
            })
            .catch((e) => {
                dispatch({
                    type: PARTICIPANT_DETACHMENT_FAILED,
                    payload: {
                        message: 'Something went wrong',
                        errors: e,
                    },
                });
            });
    },
};
